import ModuleListHeadBlock from "../Components/Modules/ModuleList/ModuleListHeadBlock";
import CourseModule from "../Components/Modules/ModuleList/CourseModule";
import Certificat from "../Components/Modules/ModuleList/Certificat";
import { createItem, readItems } from "@directus/sdk";
import { useEffect, useState } from "react";
import DirectusModuleInterface from "../Interfaces/DirectusModuleInterface";
import { useNavigate } from "react-router-dom";
import LoadingModule from "../Components/Modules/ModuleList/LoadingModule";
import TopicInterface from "../Interfaces/TopicInterface";
import { directus } from "../Api/FetchDirectus";
import HistoryInterface from "../Interfaces/HistoryInterface";
import qr from "../Assets/Images/qr.svg";
import medal from "../Assets/Images/medal.svg";
import TestApi from "../Api/TestApi";
import CertificatForm from "../Components/Modules/CertificatForm/CertificatForm";
import axios from "axios";
import CertificatApi from "../Api/CertificatApi";

const ModuleListPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const scalesHistory =
    JSON.parse(localStorage.getItem("scales") || "{}") || {};
  const [scale, setScale] = useState(0);
  const [maxScale, setMaxScale] = useState(0);
  const courseInfo = JSON.parse(localStorage.getItem("courseInfo") || "{}");
  const [moduleList, setModuleList] = useState<DirectusModuleInterface[]>([]);
  const [paidModuleList, setPaidModuleList] = useState<
    DirectusModuleInterface[]
  >([]);
  const [history, setHistory] = useState<
    HistoryInterface | Record<string, any>
  >();
  const [completedModules, setCompletedModules] = useState([]);
  const [completionList, setCompletionList] = useState<
    { id: string; complete: boolean }[]
  >([]);
  const [testAccess, setTestAccess] = useState(false);
  const [certificatAcces, setCertificatAcces] = useState(false);
  const [certificatOpen, setCertificatOpen] = useState(false);
  const [finalCertificatAcces, setFinalCertificatAcces] = useState(false);
  const certificatCompleted =
    JSON.parse(localStorage.getItem("certificat_completed") || "[]") || [];
  const [testExist, setTestExist] = useState(false);
  const contentList: TopicInterface[] = [];

  const item = {
    id: courseInfo.id,
    head: courseInfo.title,
    description:
      courseInfo.description ||
      "Курс предназначен для студентов, желающих овладеть ключевыми навыками управления и маркетинга в спортивной сфере.",
    access_type: courseInfo.access_type,
    duration: courseInfo.duration || "3 месяца",
    hours: courseInfo.hours || "300",
    document_name: courseInfo.document_name || "о повышении квалификации",
    layout: courseInfo.layout,
    background_color: courseInfo.background_color,
    test_certificat_id: courseInfo.test_certificat_id,
    certificat_hours: courseInfo.certificat_hours,
  };

  const fetchModules = async () => {
    try {
      return await directus.request(readItems(`Modules`, { limit: -1 }));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  const fetchTopicList = async () => {
    try {
      return await directus.request(readItems(`Topics`, { limit: -1 }));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  const fetchHistory = async () => {
    try {
      return await directus.request(
        readItems(`Course_History`, {
          limit: 1,
          sort: "-id",
          filter: { email: { _eq: localStorage.getItem("email") } },
        })
      );
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  async function fetchSortedModules() {
    let count = 0;

    const testList = courseInfo?.modules || [];

    const commonModuleList = await fetchModules();

    let rawList: DirectusModuleInterface[] | Record<string, any> = [];
    let rawPaidList: DirectusModuleInterface[] | Record<string, any> = [];

    testList?.forEach((item: number) => {
      commonModuleList?.forEach((module) => {
        if (module.id === item) {
          module.topics.forEach(() => {
            count = count + 1;
          });
          if (module.price_type === "free" || module.price_type === null) {
            rawList.push({
              ...module,
              scale: scalesHistory[courseInfo.id]
                ? scalesHistory[courseInfo.id][module.id]?.length
                : 0,
            });
          } else {
            rawPaidList.push({
              ...module,
              scale: scalesHistory[courseInfo.id]
                ? scalesHistory[courseInfo.id][module.id]?.length
                : 0,
            });
          }
        }
      });
    });

    setModuleList([
      ...rawList.sort(
        (a: DirectusModuleInterface, b: DirectusModuleInterface) =>
          a.module_priority > b.module_priority ? 1 : -1
      ),
    ]);

    setPaidModuleList([
      ...rawPaidList.sort(
        (a: DirectusModuleInterface, b: DirectusModuleInterface) =>
          a.module_priority > b.module_priority ? 1 : -1
      ),
    ]);

    setMaxScale(count);
  }

  useEffect(() => {
    setLoading(true);
    fetchSortedModules();

    if (scalesHistory[courseInfo.id]) {
      let count = 0;
      const courseHistory = scalesHistory[courseInfo.id];
      for (let key in courseHistory) {
        count = count + courseHistory[key]?.length;
      }

      setScale(count);
    }
    fetchHistory().then((response) => {
      setLoading(false);
      let rawLastList = [
        ...response.filter(
          (item) => item.email === localStorage.getItem("email")
        ),
      ];
      setHistory(rawLastList[rawLastList.length - 1]);
    });
  }, []);

  useEffect(() => {
    if (history?.completed) {
      const parsedCompleted = JSON.parse(history?.completed);

      if (parsedCompleted && parsedCompleted[courseInfo.id]) {
        setCompletedModules(parsedCompleted[courseInfo.id]);
      }
    }

    if (certificatCompleted.find((item: number) => item === courseInfo.id)) {
      setCertificatAcces(true);
    }

    if (
      item.test_certificat_id &&
      item.test_certificat_id !== 0 &&
      item.test_certificat_id !== null
    ) {
      setTestExist(true);
    }
  }, [history]);

  async function onModuleClick(
    content: DirectusModuleInterface,
    scale: number
  ) {
    content.scale = scale;
    const age = localStorage.getItem("age");
    const gender = localStorage.getItem("gender");
    const activity = localStorage.getItem("activity");
    const position = localStorage.getItem("position");
    localStorage.setItem("module_files", JSON.stringify(content));
    try {
      await directus.request(
        createItem("Course_History", {
          email: localStorage.getItem("email"),
          url: "/modules/module",
          course: localStorage.getItem("courseInfo"),
          scales: localStorage.getItem("scales"),
          completed: localStorage.getItem("completed"),
          certificat_completed: localStorage.getItem("certificat_completed"),
          certificat_link: localStorage.getItem("certificat_link"),
          module: JSON.stringify(content),
          date: JSON.stringify(new Date()),
          my_courses: localStorage.getItem("my_courses"),
          active_course: localStorage.getItem("active_course"),
          form: JSON.stringify({
            age: age,
            gender: gender,
            activity: activity,
            position: position,
          }),
        })
      );
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
    }

    const list = await fetchTopicList();

    const typedTopicList: TopicInterface[] = list.map(
      (item: Record<string, any>) => ({
        id: item.id,
        topic_id: item.topic_id,
        title: item.title,
        topic_name: item.topic_name,
        topic_priority: item.topic_priority,
        topic_description: item.topic_description,
        files: item.files,
        text: item.text,
        slides: item.slides,
      })
    );

    content?.topics.forEach((item: number) => {
      typedTopicList.forEach((topic: TopicInterface) => {
        if (item === topic.id) {
          contentList.push(topic);
        }
      });
    });

    window.scrollTo(0, 0);

    if (contentList.length === 1) {
      localStorage.setItem("topic_files", JSON.stringify(contentList[0]));
      localStorage.setItem("topic_list", JSON.stringify(contentList));
      localStorage.setItem("topic_order", "0");
      navigate("/modules/module/topic");

      try {
        await directus.request(
          createItem("Course_History", {
            email: localStorage.getItem("email"),
            url: "/modules/module/topic",
            course: localStorage.getItem("courseInfo"),
            module: localStorage.getItem("module_files"),
            scales: localStorage.getItem("scales"),
            completed: localStorage.getItem("completed"),
            certificat_completed: localStorage.getItem("certificat_completed"),
            certificat_link: localStorage.getItem("certificat_link"),
            topic: JSON.stringify(contentList[0]),
            date: JSON.stringify(new Date()),
            my_courses: localStorage.getItem("my_courses"),
            active_course: localStorage.getItem("active_course"),
            form: JSON.stringify({
              age: age,
              gender: gender,
              activity: activity,
              position: position,
            }),
          })
        );
      } catch (error: any) {
        sessionStorage.removeItem("token");
        navigate("/");
      }
    } else {
      navigate("/modules/module");
    }
  }

  function fullCompletion(e: { id: string; complete: boolean }) {
    setCompletionList((prevCompletionList) => [...prevCompletionList, e]);
  }

  useEffect(() => {
    if (completionList.length >= moduleList.length) {
      setTestAccess(true);
    } else {
      setTestAccess(false);
    }
  }, [completionList, moduleList]);

  async function fetchTest() {
    const data = {
      sphere: "",
      position: "",
      competencies: item.test_certificat_id ? [item.test_certificat_id] : [0],
    };

    const startTest = await TestApi.startTest(data);

    if (startTest.message === "No questions found") {
      setTestExist(false);
    } else {
      if (startTest.status === 200) {
        localStorage.setItem("question", JSON.stringify(startTest.data));
        localStorage.setItem("session_code", startTest.sessionCode);
        localStorage.setItem(
          "total_question",
          JSON.stringify(startTest.totalQuestions)
        );
        localStorage.setItem("maxScore", JSON.stringify(startTest.maxScore));
        localStorage.removeItem("test_count");
        localStorage.removeItem("radar_data");
      }
      setTestExist(true);
    }
  }

  async function fetchCertificatList() {
    console.log(1);

    const certificatList = JSON.parse(
      localStorage.getItem("certificat_link") || "[]"
    );

    console.log(certificatList);

    const currentCertificat = certificatList.find(
      (certificat: { course: string; link: string }) =>
        certificat.course === item.head
    );

    console.log(currentCertificat);

    if (currentCertificat) {
      const currentCertificatLink = currentCertificat.link.split("\n")[0];

      console.log(currentCertificatLink);

      const certificatExist = async () => {
        try {
          return await directus.request(
            readItems(`Paid_Courses`, {
              limit: 1,
              sort: "-id",
              filter: { link: { _eq: currentCertificatLink } },
            })
          );
        } catch (error: any) {
          sessionStorage.removeItem("token");
          navigate("/");
          return "";
        }
      };

      const certificatFound = await certificatExist();

      console.log(certificatFound);

      if (certificatFound.length > 0) {
        setFinalCertificatAcces(true);
      } else {
        setFinalCertificatAcces(false);
      }
    }
  }

  useEffect(() => {
    fetchCertificatList();
  }, []);

  useEffect(() => {
    if (
      item.test_certificat_id &&
      item.test_certificat_id !== 0 &&
      item.test_certificat_id !== null
    ) {
      fetchTest();
    }
  }, [item.test_certificat_id]);

  return (
    <div className="coursesListPage">
      <div className="headModuleListBlock">
        <ModuleListHeadBlock
          id={item.id}
          title={item.head}
          description={item.description}
          duration={item.duration}
          hours={item.hours}
          document_name={item.document_name}
          layout={item.layout}
          background_color={item.background_color}
          scale={scale}
          max={maxScale}
        />
      </div>
      <div className="moduleList">
        {loading ? (
          [1, 1, 1].map(() => <LoadingModule />)
        ) : (
          <>
            {moduleList.map((module, index) => {
              return (
                <CourseModule
                  key={index}
                  id={module.id}
                  moduleTitle={module.title}
                  head={module.module_name}
                  description={module.module_description}
                  themesAmount={module.topics.length}
                  testsAmount={module.test_count}
                  progress={
                    completedModules[module.id] === ""
                      ? module.scale + 1
                      : module.scale
                  }
                  max={
                    completedModules[module.id] === ""
                      ? module.topics.length
                      : module.topics.length + 1
                  }
                  fullCompletion={fullCompletion}
                  callback={() =>
                    onModuleClick(
                      module,
                      completedModules[module.id] === ""
                        ? module.scale + 1
                        : module.scale
                    )
                  }
                />
              );
            })}
            {!testExist ? null : (
              <CourseModule
                className={
                  testAccess ? "courseModule" : "courseModule disabledTopic"
                }
                moduleTitle={"Тест"}
                head={"Тест на получение сертификата"}
                description={
                  "Общее количество попыток и время прохождения не ограниченно."
                }
                callback={() => {
                  if (testAccess) navigate("/modules/module/certificat_test");
                }}
              ></CourseModule>
            )}
          </>
        )}
      </div>
      <form></form>
      <Certificat
        name="Получение электронного сертификата"
        description="Электронный сертификат подтверждает прохождение базовой части курса
            и дает право перейти на продвинутый уровень и получить удостоверение
            о повышении квалификации"
        img={qr}
        className={
          certificatAcces
            ? "getCertificatBox"
            : "getCertificatBox disabledCertificat"
        }
        callback={() => {
          if (certificatAcces) {
            CertificatApi.sendCertificat();
          }
        }}
      />
      <div className="moduleList">
        {loading
          ? [1, 1, 1].map(() => <LoadingModule />)
          : paidModuleList.map((module, index) => {
              return (
                <CourseModule
                  key={index}
                  className={
                    finalCertificatAcces
                      ? "courseModule"
                      : "courseModule disabledTopic"
                  }
                  id={module.id}
                  moduleTitle={module.title}
                  head={module.module_name}
                  description={module.module_description}
                  themesAmount={module.topics.length}
                  testsAmount={module.test_count}
                  progress={
                    completedModules[module.id] === ""
                      ? module.scale + 1
                      : module.scale
                  }
                  max={
                    completedModules[module.id] === ""
                      ? module.topics.length
                      : module.topics.length + 1
                  }
                  fullCompletion={fullCompletion}
                  callback={() => {
                    if (finalCertificatAcces) {
                      onModuleClick(
                        module,
                        completedModules[module.id] === ""
                          ? module.scale + 1
                          : module.scale
                      );
                    }
                  }}
                />
              );
            })}
      </div>
      {item.access_type !== "free" && (
        <Certificat
          name="Получение удостоверения о повышении квалификации"
          description="Удостоверение подтверждает прохождение продвинутой части курса"
          img={medal}
          className={
            finalCertificatAcces
              ? "getCertificatBox"
              : "getCertificatBox disabledCertificat"
          }
        />
      )}
      {certificatOpen && (
        <CertificatForm
          course={item.head}
          certificat_hours={item.certificat_hours}
        />
      )}
    </div>
  );
};

export default ModuleListPage;
